// extracted by mini-css-extract-plugin
var _1 = "MobilePointsView_arrow__f3f15";
var _2 = "MobilePointsView_close__b67b3";
var _3 = "MobilePointsView_disabled__792f8";
var _4 = "MobilePointsView_navigation__edf92";
var _5 = "MobilePointsView_root__aa4e9";
var _6 = "MobilePointsView_slider__90caa";
var _7 = "MobilePointsView_tooltip__e71b9";
export { _1 as "arrow", _2 as "close", _3 as "disabled", _4 as "navigation", _5 as "root", _6 as "slider", _7 as "tooltip" }
